export default {
      id: "ic_disallowed-usage",
      viewBox: "0 0 15 15",
      url: "/" + "images/icons.3.109.2.svg#ic_disallowed-usage",
      toString: function () {
        return this.url;
      }
    }